export function handleGetExtension(file:string){
    const tam = file.length;
   const  extension  = file.substring(tam-3).toLowerCase();
    console.log(extension)
   return extension;

}